import React from 'react';
import { ThumbsUpIcon, MessageSquareIcon, ShareIcon, UsersIcon } from 'lucide-react';
const GroupFeedWidget = () => {
  return <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-524">
      <div className="p-4 flex justify-between items-center" data-id="element-525">
        <h2 className="text-base font-semibold text-gray-800" data-id="element-526">
          Feed dai Gruppi
        </h2>
        <button className="text-sm text-gray-500 hover:text-gray-700" data-id="element-527">
          Tutti i gruppi
        </button>
      </div>
      <div className="p-4" data-id="element-528">
        <div className="space-y-4" data-id="element-529">
          <FeedItem groupName="Innovatori ESG" authorName="Laura Neri" authorAvatar="https://i.pravatar.cc/150?img=23" time="2 ore fa" content="Ho appena pubblicato un nuovo report sulle strategie di transizione energetica nel settore manifatturiero. Fatemi sapere cosa ne pensate!" likes={24} comments={8} hasImage={true} imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/91SHa3uVeGUZjphgY5kVCZ/IMG_0009.jpg" data-id="element-530" />
          <FeedItem groupName="Economia Circolare" authorName="Giovanni Rossi" authorAvatar="https://i.pravatar.cc/150?img=68" time="Ieri" content="Qualcuno ha partecipato al webinar sulla nuova direttiva europea per la plastic tax? Vorrei confrontarmi sui punti principali discussi." likes={12} comments={17} hasImage={false} data-id="element-531" />
        </div>
      </div>
      <div className="px-4 py-3 bg-gray-50 border-t border-gray-200" data-id="element-532">
        <button className="w-full text-sm text-custom-green hover:text-custom-green/90 font-medium" data-id="element-533">
          Visualizza altri post
        </button>
      </div>
    </div>;
};
interface FeedItemProps {
  groupName: string;
  authorName: string;
  authorAvatar: string;
  time: string;
  content: string;
  likes: number;
  comments: number;
  hasImage: boolean;
  imageUrl?: string;
}
const FeedItem: React.FC<FeedItemProps> = ({
  groupName,
  authorName,
  authorAvatar,
  time,
  content,
  likes,
  comments,
  hasImage,
  imageUrl
}) => {
  return <div className="border border-gray-200 rounded-lg p-3" data-id="element-534">
      <div className="flex items-center mb-3" data-id="element-535">
        <div className="w-10 h-10 rounded-full overflow-hidden mr-3" data-id="element-536">
          <img src={authorAvatar} alt={authorName} className="w-full h-full object-cover" data-id="element-537" />
        </div>
        <div data-id="element-538">
          <h3 className="font-medium text-gray-800" data-id="element-539">{authorName}</h3>
          <div className="flex items-center text-xs text-gray-500" data-id="element-540">
            <UsersIcon size={12} className="mr-1" data-id="element-541" />
            <span data-id="element-542">{groupName}</span>
            <span className="mx-1" data-id="element-543">•</span>
            <span data-id="element-544">{time}</span>
          </div>
        </div>
      </div>
      <p className="text-sm text-gray-700 mb-3" data-id="element-545">{content}</p>
      <div className="flex justify-between text-xs text-gray-500" data-id="element-546">
        <div className="flex items-center" data-id="element-547">
          <ThumbsUpIcon size={14} className="mr-1" data-id="element-548" />
          <span data-id="element-549">{likes}</span>
        </div>
        <div data-id="element-550">{comments} commenti</div>
      </div>
      <div className="flex justify-between mt-3 pt-3 border-t border-gray-100" data-id="element-551">
        <button className="flex items-center text-xs text-gray-600 hover:text-gray-800" data-id="element-552">
          <ThumbsUpIcon size={14} className="mr-1" data-id="element-553" />
          Mi Piace
        </button>
        <button className="flex items-center text-xs text-gray-600 hover:text-gray-800" data-id="element-554">
          <MessageSquareIcon size={14} className="mr-1" data-id="element-555" />
          Commenta
        </button>
        <button className="flex items-center text-xs text-gray-600 hover:text-gray-800" data-id="element-556">
          <ShareIcon size={14} className="mr-1" data-id="element-557" />
          Condividi
        </button>
      </div>
    </div>;
};
export default GroupFeedWidget;